export default "__VITE_ASSET__D3n7P84e__"